module.exports = __webpack_public_path__ + "static/media/synth-warning.cfb8326c.webm";